exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".expand-enter-active,.expand-leave-active{overflow:hidden;transition:height .35s ease}.expand-enter,.expand-leave-to{height:0}", ""]);

